import React, { useState } from "react";
import InputBox from "../../Component/UI/InputBox";
import AddButton from "../../Component/UI/AddButton";

export default function UpdateUserModal({ onClose, updateForm, handleUpdateChange, onSubmit }) {

  const fields = [
    { label: "Team Name", name: "name" }
  ];

  const [form, setForm] = React.useState({
    name: ""
  });


  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal Container */}
      <div className="relative bg-white w-full max-w-3xl rounded-2xl p-8 z-10">
        {/* Title */}
        <h2 className="text-xl font-semibold mb-4">Update Team</h2>

        {/* Form */}
        <div className="space-y-4">
          {fields.map(({ label, name }) => (
            <InputBox
              key={name}
              label={label}
              name={name}
              value={updateForm[name]}
              onChange={handleUpdateChange}
            />
          ))}
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Cancel</button>
          <AddButton title="Update" className="bgcolor text-white px-6" onClick={() => onSubmit(updateForm)} />
        </div>

      </div>

    </div>
  );
}
